// extracted by mini-css-extract-plugin
module.exports = {"netError":"netError__3WOQl","img":"img__1tLjV","message":"message__3capp","btn":"btn__3jINs"};